import React, { useEffect, useState, useRef } from "react";
import api from "../../../../services/api"; // Assuming api service exists


// Define the data interface based on previous grid
interface Chamada {
    ordem: string | number;
    data_agendamento_terminal: string;
    motorista: string;
    placa: string;
    terminal: string;
}

const PainelChamadasBoard: React.FC = () => {
    const [chamadas, setChamadas] = useState<Chamada[]>([]);

    const chamadasRef = useRef<Chamada[]>([]);

    useEffect(() => {
        chamadasRef.current = chamadas;
    }, [chamadas]);

    useEffect(() => {
        const narrate = () => {
            const items = chamadasRef.current;
            if (items.length > 0 && 'speechSynthesis' in window) {
                window.speechSynthesis.cancel();
                items.forEach((item) => {
                    const text = `motorista ${item.motorista} da Placa ${item.placa}. Comparecer ao atendimento.`;
                    const utterance = new SpeechSynthesisUtterance(text);
                    utterance.lang = 'pt-BR';
                    window.speechSynthesis.speak(utterance);
                });
            }
        };

        const interval = setInterval(narrate, 60000);

        return () => {
            clearInterval(interval);
            window.speechSynthesis.cancel();
        };
    }, []);

    const formatDate = (dateString: string) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const formatTime = (dateString: string) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
    };

    // Fetch data 
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await api.post("/painelChamadas", {
                    qtd_por_pagina: 10,
                    order_by: "data_agendamento_terminal",
                    order_direction: "asc"
                });

                console.log("Painel Chamadas Response:", response.data);

                // Assuming the structure from typical paginated responses in this project
                if (response.data && response.data.data) {
                    setChamadas(response.data.data);
                } else if (Array.isArray(response.data)) {
                    setChamadas(response.data);
                }
            } catch (error) {
                console.error("Erro ao buscar chamadas", error);
            }
        };

        fetchData();

        // Auto refresh
        const interval = setInterval(fetchData, 15000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex flex-col w-full h-screen bg-[#001f3f]">
            {/* Header */}
            <div className="flex w-full bg-[#003366] text-white border-b-4 border-[#001f3f]">

                <div className="flex-1 p-4 font-bold text-2xl uppercase border-r border-[#004080]">Data</div>
                <div className="flex-1 p-4 font-bold text-2xl uppercase border-r border-[#004080]">Hora</div>
                <div className="flex-1 p-4 font-bold text-2xl uppercase border-r border-[#004080]">Motorista</div>
                <div className="flex-1 p-4 font-bold text-2xl uppercase border-r border-[#004080]">Placa</div>
                <div className="flex-1 p-4 font-bold text-2xl uppercase">Terminal</div>
            </div>

            {/* List */}
            <div className="flex-1 overflow-auto">
                {chamadas.map((item, index) => (
                    <div key={index} className="flex w-full text-white border-b border-[#004080] odd:bg-[#002b55] even:bg-[#003366]">

                        <div className="flex-1 p-4 text-xl font-medium border-r border-[#004080]">{formatDate(item.data_agendamento_terminal)}</div>
                        <div className="flex-1 p-4 text-xl font-medium border-r border-[#004080]">{formatTime(item.data_agendamento_terminal)}</div>
                        <div className="flex-1 p-4 text-xl font-medium border-r border-[#004080]">{item.motorista}</div>
                        <div className="flex-1 p-4 text-xl font-medium border-r border-[#004080]">{item.placa}</div>
                        <div className="flex-1 p-4 text-xl font-medium">{item.terminal}</div>
                    </div>
                ))}
                {/* Empty State / Skeleton if needed */}
                {chamadas.length === 0 && (
                    <div className="p-10 text-center text-white opacity-50 text-2xl">
                        Aguardando chamadas...
                    </div>
                )}
            </div>
        </div>
    );
};

export default PainelChamadasBoard;
